<template>
  <Photoswipe
    v-if="shouldRender"
    :gid="gid"
    :gallery-items="galleryItems"
    :options="options"
  >
    <template #default="{ openGallery }">
      <button
        :class="className"
        @click="onButtonClick(openGallery)"
      >
        {{ text }}
      </button>
    </template>
  </Photoswipe>
</template>

<script>
import API from '../js/modules/api';
import Photoswipe from './photoswipe/Photoswipe.vue';
import { getUrlParams } from './photoswipe/photoswipe';

export default {

  name: 'GalleryButton',

  components: { Photoswipe },
  inheritAttrs: false,

  props: {
    className: {
      type: String,
      required: false,
      default: null,
    },

    text: {
      type: String,
      required: false,
      default: null,
    },

    id: {
      type: Number,
      required: true,
    },

    resource: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    isInitialized: false,
    galleryItems: [],
    gid: null,
    options: {
      shareButtons: [
        { id: 'facebook', label: 'Share on Facebook', url: 'https://www.facebook.com/sharer/sharer.php?u={{url}}' },
        { id: 'linkedin', label: 'Share on LinkedIn', url: 'https://www.linkedin.com/sharing/share-offsite/?url={{url}}' },
        { id: 'twitter', label: 'Tweet', url: 'https://twitter.com/intent/tweet?text={{text}}&url={{url}}' },
        { id: 'pinterest', label: 'Pin it', url: 'http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}' },
        {
          id: 'download', label: 'Download image', url: '{{raw_image_url}}', download: true,
        },
      ],
    },
  }),

  computed: {
    hasUrlParams() {
      const { pid, gid } = getUrlParams();
      return pid && gid;
    },

    shouldRender() {
      return (!this.hasUrlParams || (this.hasUrlParams && this.galleryItems.length));
    },
  },

  created() {
    if (this.hasUrlParams) {
      this.fetchMedia();
    }
  },

  methods: {
    async fetchMedia() {
      try {
        const { gid, media } = await API()
          .getPropertyMedia(this.id, this.resource);

        this.galleryItems = media;
        this.gid = gid;
      } catch (e) {
        console.error('Unable to fetch images', {
          id: this.id,
          error: e,
        });
      } finally {
        this.isInitialized = true;
      }
    },

    async onButtonClick(openGallery) {
      if (!this.isInitialized) {
        await this.fetchMedia();
      }

      await this.$nextTick();

      openGallery();
    },
  },
};
</script>
